export default {
  registration: () => '/registration',
  login: () => '/login',
  recovery: () => '/recovery',
  my: () => '/my',
  law: () => '/law',
  verify: () => '/verify',
};



// WEBPACK FOOTER //
// ./src/shared/constants/url.js